import { Skeleton } from '@mui/material';
import React from 'react';

export const SkeletonProfile = () => {
  return (
    <div className='mt-2'>
      <Skeleton
        variant='rectangular'
        sx={{
          bgcolor: 'grey.900',
          width: '100%',
          borderRadius: '.4rem',
          height: 582,
        }}
      />
    </div>
  );
};
